goog.provide('yext.storm.base');

goog.require('yext.a11y.a11yclick');
/** @suppress {extraRequire} */
goog.require('yext.plugins.UserAgent');

(function() {
  /**
   * Inherit the prototype methods from one constructor into another.
   *
   * Usage:
   * <pre>
   * function ParentClass(a, b) { }
   * ParentClass.prototype.foo = function(a) { }
   *
   * function ChildClass(a, b, c) {
   *   ParentClass.call(this, a, b);
   * }
   *
   * window.inherits(ChildClass, ParentClass);
   *
   * var child = new ChildClass('a', 'b', 'see');
   * child.foo(); // works
   * </pre>
   *
   * In addition, a superclass' implementation of a method can be invoked
   * as follows:
   *
   * <pre>
   * ChildClass.prototype.foo = function(a) {
   *   ChildClass.superClass_.foo.call(this, a);
   *   // other code
   * };
   * </pre>
   *
   * @param {Function} childCtor Child class.
   * @param {Function} parentCtor Parent class.
   */
  window.inherits = function(childCtor, parentCtor) {
    /** @constructor */
    function tempCtor() {}
    tempCtor.prototype = parentCtor.prototype;
    childCtor.superClass_ = parentCtor.prototype;
    childCtor.prototype = new tempCtor();
    childCtor.prototype.constructor = childCtor;
  };

  // Search through a collection of elements looking for a string
  // Note: mirrors $('selector:contains("string")') but is case insensitive
  // Usage: $('selector:containsIgnoreCase("string")')
  /** @suppress {missingProperties} */
  $.expr[':']['containsIgnoreCase'] = function(n, i, m) {
    return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  // Browser detection is deprecated in jQuery 1.9+ and instead uses feature support.
  // Building in feature support is much more of a headache then the browser detection
  // so we added the functionality back to jQuery to support existing plugins (e.g. history.js)
  if (!jQuery.browser) {
    jQuery.browser = {};
    jQuery.browser.mozilla = /mozilla/.test(navigator.userAgent.toLowerCase()) && !/webkit/.test(navigator.userAgent.toLowerCase());
    jQuery.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
    jQuery.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
    jQuery.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
  }

  // Support string trim in IE8
  if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
      return this.replace(/^\s+|\s+$/g, '');
    };
  }
})();
